import { render, staticRenderFns } from "./FilterFunds.vue?vue&type=template&id=f40560ae&scoped=true"
import script from "./FilterFunds.vue?vue&type=script&lang=js"
export * from "./FilterFunds.vue?vue&type=script&lang=js"
import style0 from "./FilterFunds.vue?vue&type=style&index=0&id=f40560ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40560ae",
  null
  
)

export default component.exports